<template>
    <div  style="background: #FAFAFA; padding: 30px 0;">
        <div class="container" style="padding-top: 0.5rem; padding-bottom: 3rem; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.05); background: #ffffff;">
            <div class="top-spot mt-5">
                <h5 @click="goBack()"><span v-if="currentStep === 0"><i class="fa fa-chevron-left"></i></span>  Register Your Superkid</h5>
            </div>
            <div>
                <div>
                    
                    <div class="form">
                        <div class="header-top">
                            <h4>{{ steps[currentStep] }}</h4>
                            <p>{{ substeps[currentSubStep] }}</p>
                        </div>
                        <div v-if="currentStep === 0">
                            <!-- <div class="header-top">
                                <h4>Child Information</h4>
                                <p>Fill in the details to start your kids' SuperKids journey.</p>
                            </div> -->
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="displayname"> Display name</label>
                                        <input v-model="registrationForm.dname" type="text" class="form-control inputt" id="displayname" placeholder="Enter user name">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="fname"> First name</label>
                                        <input v-model="registrationForm.fname" type="text" class="form-control inputt" id="fname" placeholder="Enter user name">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="lname"> Last name</label>
                                        <input v-model="registrationForm.lname" type="text" class="form-control inputt" id="lname" placeholder="Enter user name">
                                    </div>
                                </div>
                                <!-- <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="nin">National Identification Number (NIN)</label>
                                        <input v-model="registrationForm.nin" maxlength="11" title="Please enter exactly 11 digits"  type="number" class="form-control inputt" id="nin" placeholder="Enter NIN">
                                    </div>
                                </div> -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="displayname"> Date of birth (Ages 6-12)</label>
                                        <input v-model="registrationForm.dob" :min="minDate" :max="maxDate"  format="DD/MM/YYYY" value-type="format" type="date" class="form-control inputt" id="dob" placeholder="Date of birth">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="gender">Gender</label>
                                        <!-- <input type="date" class="form-control inputt" id="dob" placeholder="Date of birth"> -->
                                        <select class="form-control inputt" name="" id="gender" v-model="registrationForm.gender">
                                            <option class="" value="" disabled selected>Select gender</option>
                                            <option class="" value="male">Male</option>
                                            <option class="" value="female">Female</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="handler">Handler</label>
                                        <!-- <input type="date" class="form-control inputt" id="dob" placeholder="Date of birth"> -->
                                        <select class="form-control inputt" name="handler" id="handler" v-model="registrationForm.parent_or_guardian">
                                            <option class="" value="" disabled selected>Select Handler</option>
                                            <option class="" value="parent">Parent</option>
                                            <option class="" value="guardian">Guardian</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="mot">Mother Tongue</label>
                                        <input v-model="registrationForm.monther_tongue" type="text" class="form-control inputt" id="mot" placeholder="Enter mother tongue language">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="mot">Foreign language</label>
                                        <input v-model="registrationForm.foreign_language" type="text" class="form-control inputt" id="mot" placeholder="Enter foreign language">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group search-container position-relative">
                                        <label for="sname">Search for school<span>
                                            <i
                                                class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                                v-if="searchloader"
                                                ></i>
                                            </span> 
                                         </label> 
                                        <div class="input-group">
                                            <input v-model="registrationForm.school_name" title="Search then school"  type="text" class="form-control inputt" id="sname" placeholder="Search shool name and select">
                                            <div class="input-group-append">
                                                <button :disabled="searchloader || registrationForm.school_name.length == 0" @click="searchSchools()" class="input-group-text" id="basic-addon2">
                                                   {{ searchloader ? 'Loading' : 'Search' }}
                                                    <i
                                                    class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                                    v-if="searchloader"
                                                    ></i>
                                                </button>
                                            </div>
                                        </div>
                                        <ul 
                                            v-if="showDropdown && filteredSchools.length > 0" 
                                            class="list-group position-absolute w-100 shadow-sm" 
                                            style="z-index: 1000; top: 100%; max-height: 200px; overflow-y: auto;"
                                            >
                                            <li 
                                                v-for="school in filteredSchools" 
                                                :key="school.id"
                                                class="list-group-item list-group-item-action"
                                                style="cursor: pointer;"
                                                @mousedown="selectSchool(school)"
                                            >
                                                {{ school.school_name }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <hr>
                                <div class="form-group">
                                    <div class="col-md-6 pr-0 pl-0">
                                        <!-- <label for="">And School if child's school is not found from the search</label>
                                        <button class="btn openSchoolAction" v-if="showSchoolBtn" @click="showSchoolBtn = false">Add School</button> -->

                                        <div class="radio-options">
                                            <div class="form-group form-check">
                                                <input  v-model="showSchoolBtn"  type="checkbox" class="form-check-input" id="schooloption">
                                                <label class="form-check-label" for="schooloption">
                                                    Add school if child's school is not found from the search
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>
                        </div>
                        <div v-if="currentStep === 1">
                            <!-- <div class="header-top">
                                <h4>Select Challenge Category</h4>
                                <p>Select at least one category of interest for your child.</p>
                            </div> -->
                            <div class="">
                                <div class="row custom-mobile-row">
                                    <div class="col-6 col-lg-3 mb-3" v-for="item in challenges" :key="item.id">
                                        <div class="challenge-item">
                                            <img :src="item.imageUrl" class="card-img-top" @click="isSelected; toggleSelection(item.id)" :class="{ 'activePick': isSelected(item.id) }">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="currentStep === 2">
                           <div class="form-group">
                                <label for="twp">Does Your Child have Special Needs?</label>
                                <div class="radio-options">
                                    <div class="form-check">
                                        <input v-model="registrationForm.special_need" class="form-check-input" type="radio" name="sn" id="sny" value="yes">
                                        <label class="form-check-label" for="sny">
                                        YES
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input v-model="registrationForm.special_need" class="form-check-input" type="radio" name="twp" id="snn" value="no">
                                        <label class="form-check-label" for="snn">
                                        NO
                                        </label>
                                    </div>
                                </div>
                           </div>
                           <div class="form-group">
                                <label for="twp">How did you hear about Superkids?</label>
                                <div class="radio-options">
                                    <div class="form-check">
                                        <input v-model="registrationForm.how_did_you_hear_about_super_kid" class="form-check-input" type="radio" name="twp" id="hdyh1" value="Shelta App">
                                        <label class="form-check-label" for="hdyh1">
                                        Shelta App
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input v-model="registrationForm.how_did_you_hear_about_super_kid" class="form-check-input" type="radio" name="hdyh" id="hdyh2" value="facebook">
                                        <label class="form-check-label" for="hdyh2">
                                        Facebook
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input v-model="registrationForm.how_did_you_hear_about_super_kid" class="form-check-input" type="radio" name="hdyh" id="hdyh3" value="some one i knoe">
                                        <label class="form-check-label" for="hdyh3">
                                        Someone I know
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input v-model="registrationForm.how_did_you_hear_about_super_kid" class="form-check-input" type="radio" name="hdyh" id="hdyh4" value="event/program">
                                        <label class="form-check-label" for="hdyh4">
                                        Event/Program
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input v-model="registrationForm.how_did_you_hear_about_super_kid" class="form-check-input" type="radio" name="hdyh" id="hdyh5" value="others">
                                        <label class="form-check-label" for="hdyh5">
                                        Others
                                        </label>
                                    </div>
                                </div>
                           </div>

                          
                            <div class="radio-options">
                                <div class="form-group form-check">
                                    <input  v-model="registrationForm.consent" type="checkbox" class="form-check-input" id="concent" true-value="yes" false-value="no">
                                    <label class="form-check-label" for="concent">
                                        I give consent for my child to participate in the SuperKids Program.
                                    </label>
                                </div>
                                <div class="form-group form-check">
                                    <input v-model="registrationForm.receive_updates" type="checkbox" class="form-check-input" id="update" true-value="yes" false-value="no">
                                    <label class="form-check-label" for="update">
                                        I agree to receive updates and rewards information via WhatsApp/SMS.
                                    </label>
                                </div>
                            </div>
                           
                        </div>

                        <div class="vote-btn d-flex gap-2 w-100">
                            <button @click="prev" v-if="currentStep != 0" class="btn vote-now flex-fill mr-2" >Back</button>
                            <button @click="next" v-if="currentStep != 2" :disabled="currentStep === steps.length - 1" class="btn vote-now flex-fill">Proceed</button>
                            <button v-if="currentStep == 2" class="btn vote-now" :disabled="loader" @click="registerKid()">
                                {{ loader ? 'Please wait...' : 'Register' }}
                                <i
                                class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                v-if="loader"
                                ></i>
                            </button>
                        </div>

                        <div class="modal fade" id="addSchoolModal" tabindex="-1" aria-labelledby="addSchoolModal" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title title-modal" id="addSchoolModal">Add School</h5>
                                        <button @click="closeModal(); showSchoolBtn = false;" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body mt-4">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group" v-if="showSchoolBtn">
                                                    <label for="sname"> School name</label>
                                                    <input v-model="addSchholForm.name" type="text" class="form-control inputt" id="sname" placeholder="Enter school name">
                                                </div>
                                            </div>
                                            <div class="col-md-6" v-if="showSchoolBtn">
                                                <div class="form-group">
                                                    <label for="semail"> School email</label>
                                                    <input v-model="addSchholForm.email" type="text" class="form-control inputt" id="semail" placeholder="Enter school email">
                                                </div>
                                            </div>
                                            <div class="col-md-12" v-if="showSchoolBtn">
                                                <div class="form-group">
                                                    <label for="sstate"> School state</label>
                                                    <!-- <select name="" id="" v-for="item in states" :index="item.id">
                                                        <option value="">{{ item }}</option>
                                                    </select> -->

                                                    <select class="form-control inputt" name="handler" id="handler" v-model="addSchholForm.state">
                                                        <option class="" value="">Select state</option>
                                                        <option class="" :value="item" v-for="item in states" :index="item">{{item}}</option>
                                                    </select>
                                                    <!-- <input v-model="addSchholForm.state" type="text" class="form-control inputt" id="sstate" placeholder="Enter school state"> -->
                                                </div>
                                            </div>
                                            <div class="col-md-12 open-add-sch-btn">
                                                <label v-if="showSchoolBtn" for="">Action</label>
                                                <div v-if="showSchoolBtn" class="d-flex">
                                                    <button class="btn openSchool mr-3" @click="addSchool()" :disabled="addSchoolLoader">
                                                        Submit School
                                                        <i
                                                            class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                                            v-if="addSchoolLoader"
                                                            >
                                                        </i>
                                                    </button>
                                                    <button class="btb cancel" @click="showSchoolBtn = false; closeModal()">Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="loader">
                <PageLoader></PageLoader>
            </div>
        </div>
    </div>
</template>



<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
import $ from "jquery";
export default {
    name: "RegisterKid",
    components: {
        // Header
        PageLoader,
    },
    data() {
        return {
            loader: false,
            searchQuery: '',
            showSchoolBtn: false,
            showDropdown: false,
            searchloader: false,
            addSchoolLoader: false,
            selectedSchool: null,
            filteredSchools: [],
            step1: true,
            step2: false,
            step3: false,
            currentStep: 0,
            currentSubStep: 0,
            challengePicked: null,
            challenges: [],
            steps: [
                "Child Information",
                "Select Challenge Category",
                "Additional Information",
            ],
            substeps: [
                "Fill in the details to start your kids' SuperKids journey.",
                "Select at least one or at most two categories of interest for your child.",
                "Fill in the details to start your kids' SuperKids journey."
            ],
            stepFields: {
                0: ["fname", "lname", "dname", "dob", "gender", "parent_or_guardian", "school_name"],
                1: ["challengesIds"],    
                2: ["special_need", "how_did_you_hear_about_super_kid", "consent", "receive_updates"],
                3: [] 
            },
            registrationForm: {
                fname: "",
                lname: "",
                dname: "",
                nin: "",
                dob: "",
                gender: "",
                school_name: "",
                challengesIds: [],
                special_need: "",
                challenge_categories: "",
                parent_or_guardian: "",
                how_did_you_hear_about_super_kid: "", 
                consent: "",
                receive_updates: "",
                monther_tongue: "",
                foreign_language: "",
                
            },
            addSchholForm: {
                name: "",
                email: "",
                state: "",
            },
            schoolId: "",
            challengesIds: [],
            states: [],
            
        }
    },
    watch: {
        // Watch the checkbox state
        showSchoolBtn(newValue) {
            if (newValue === true) {
                $("#addSchoolModal")
                .addClass("fade")
                .modal("show");
            } else {
                $("#addSchoolModal")
                .removeClass("fade")
                .modal("hide");
    
            }
        }
    },
    // watch: {
    //     "registrationForm.school_name": function(newVal) {
    //     if (newVal.length < 2) {
    //         this.results = [];
    //         this.searchloader = false;
    //         this.showDropdown = false;
    //         return;
    //     }
    //     // Call the debounced version created in the hook
    //     this.debouncedSearch(newVal);
    //     }
    // },
    computed: {
        // Generates '2026-03-01' format for the :max attribute
        today() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
        },

        minDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear() - 12);
            return date.toISOString().split('T')[0];
        },
        
        // 6 years ago from today (Latest possible valid birthday)
        maxDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear() - 6);
            return date.toISOString().split('T')[0];
        },
    },
    created() {
        // this.debouncedSearch = this.debounce(this.searchSchools, 500);
    },
    mounted() {
        this.fetchChallengeCategories();
        this.fetchStates();
    },
    methods: {
        closeModal() {
            this.showSchoolBtn = false;
            $("#addSchoolModal")
                .removeClass("fade")
                .modal("hide");
        },
        goBack() {
            this.$router.back();
        },
        prev() {
            if (this.currentStep > 0) {
                this.currentStep--;
            }
            if (this.currentSubStep > 0) {
                this.currentSubStep--;
            }
        },
        next() {
            const validation = this.isCurrentStepValid();

            if (validation !== true) {
                this.$store.commit("setApiFailed", validation);
                return;
            }
            if (this.currentStep < this.steps.length - 1) {
                this.currentStep++;
            }
            if (this.currentSubStep < this.substeps.length - 1) {
                this.currentSubStep++;
            }
        },
        isCurrentStepValid() {
            const required = this.stepFields[this.currentStep] || [];

            for (let field of required) {
                const value = this.registrationForm[field];

                // Special rule for challengesIds (Step 2)
                if (field === "challengesIds") {
                    if (!Array.isArray(value) || value.length === 0) {
                        return "Please select at least one challenge";
                    }
                }

                // Array validation (generic)
                if (Array.isArray(value)) {
                    if (value.length === 0) {
                        return "Please fill all required fields";
                    }
                }

                // String validation
                if (typeof value === "string" && value.trim() === "") {
                    return "Please fill all required fields";
                }

                if (value === null || value === undefined) {
                    return "Please fill all required fields";
                }
            }
            return true;
        },

        toggleSelection(id) {
            const idStr = String(id);    
            // 2. Find the index in your string array
            const index = this.registrationForm.challengesIds.indexOf(idStr);

            if (index > -1) {
            // If found, remove the string ID
            this.registrationForm.challengesIds.splice(index, 1);
            } else {
                if (this.registrationForm.challengesIds.length >= 2) {
                    return this.$store.commit("setApiFailed", "Maximum selection reached");
                }
            // If not found, push the string ID
                this.registrationForm.challengesIds.push((idStr));
            }
        },
        isSelected(id) {
            return this.registrationForm.challengesIds.includes(String(id));
        },

        async fetchChallengeCategories() {
            this.loader = true;
            try {
                await Api.getRequest(`fetch-all-challenge-categories`) // fetch-challenge-categories 
                .then(res => {
                this.loader = false;
                // console.log("Category", res)
                // this.$root.$refs.openSuccess.openSuccessModal();
                if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                if (res.data.success) {
                   this.challenges = res.data.data;
                   const imageLibrary = {
                        1: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772108828/art-attack_esxwwb.svg",
                        2: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772108829/super-speeches_erd9tu.svg",
                        3: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772111385/Challenge_card_small_1_exf8wa.svg",
                        4: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772115783/Challenge_card_small_odcrgw.svg",
                        5: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772115521/Challenge_card_small_loeroa.svg",
                        6: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772115606/Challenge_card_small_uymxk2.svg",
                        7: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772115926/Challenge_card_small_lb1lmy.svg",
                        8: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772111385/Challenge_card_small_whqefx.svg",
                        9: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1781518120/waste-to-worth-cate_itv1fa.svg"
                    };

                    this.challenges = this.challenges.map(item => ({
                        ...item,
                        // It looks for the URL by ID; if not found, it uses a placeholder
                        imageUrl: imageLibrary[item.id] || "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772111385/Challenge_card_small_whqefx.svg"
                    }));
                    // console.log("Challenges", this.challenges)
                }
            }).catch(err => {
                    // this.loader2 = false;
                    this.loader = false;
                });
            } finally {
            // console.log("Closed connection");
            }
        },
        async fetchStates() {
            try {
                await Api.getRequest(`fetch-super-kid-states`).then(res => {
                    // console.log("States:", res)
                    this.states = res.data.data;
                }).catch(err => {
                    console.log("Error:", err);
                })
            } finally {
                // console.log("cloased")
            }
        },
        async addSchool () {
            if (this.addSchool.name == "") {
                return this.$store.commit("setApiFailed", 'Enter school name');
            }
            if (this.addSchool.state == "") {
                return this.$store.commit("setApiFailed", 'Select school state');
            }
            this.addSchoolLoader = true;
            try {
                await Api.postRequest(`add-super-kid-school`, {
                    school_name: this.addSchholForm.name,
                    email: this.addSchholForm.email,
                    state: this.addSchholForm.state,
                }).then(res => {
                    // console.log("Schhol response:", res);
                    this.addSchoolLoader = false;
                    if (res.data.success) {
                        this.schoolId = res.data.data.id;
                        this.showSchoolBtn = false;
                        this.registrationForm.school_name = res.data.data.school_name;
                        return this.$store.commit("setApiSuccess", "School added successfull");
                    }
                }).catch(err => {
                    console.log("Error:", err);
                    this.addSchoolLoader = false;
                })
            } finally {
                // console.log("closed")
            }
        },

        async registerKid() {
            if (this.registrationForm.special_need == '' || this.registrationForm.how_did_you_hear_about_super_kid == '' || this.registrationForm.consent == '' || this.registrationForm.receive_updates == '') {
                return this.$store.commit("setApiFailed", "Enter or Select all required fields");
            }
            this.loader = true;
            try {
                const payloads = {
                    firstname: this.registrationForm.fname,
                    lastname: this.registrationForm.lname,
                    display_name: this.registrationForm.dname,
                    gender: this.registrationForm.gender,
                    school_id: this.schoolId,
                    challenge_categories: JSON.stringify(this.registrationForm.challengesIds),
                    how_did_you_hear_about_super_kid: this.registrationForm.how_did_you_hear_about_super_kid,
                    // nin: this.registrationForm.nin,
                    consent: this.registrationForm.consent,
                    receive_updates: this.registrationForm.updates,
                    parent_or_guardian: this.registrationForm.parent_or_guardian,
                    monther_tongue: this.registrationForm.monther_tongue,
                    foreign_language: this.registrationForm.foreign_language,
                    date_of_birth: moment(this.registrationForm.dob).format('DD-MM-YYYY'),
                    
                }
                Api.postRequest(`parent-register-kid`, JSON.stringify(payloads)).then(res => {
                    this.loader = false;
                    // console.log("registration successful", res)
                    if (res.data.success) {
                        this.currentStep = 0;
                        this.currentSubStep = 0;
                        
                        this.$router
                            .push({
                            path: `/dashboard/superkid-dashboard`
                            })
                            .catch(() => {
                            // console.log("none")
                        });
                        return this.$store.commit("setApiSuccess", "Success");
                    }
                    if(res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                }).catch(err => {
                    console.log(err);
                    this.loader = false;
                });

            } finally {
                // console.log("CLOSED")
            }
        },

        async searchSchools() {
            this.searchloader = true;
            this.showDropdown = false;
            try {
                await Api.postRequest(`search-school`, {school_name: this.registrationForm.school_name}).then(res => {
                    // console.log("School search", res);
                    this.searchloader = false;
                    this.showDropdown = true;
                    this.filteredSchools = res.data.data;
                }).catch((err) => {
                    this.searchloader = false;
                    console.log("error", err)
                })
            } finally {
                // console.log("closed")
            }
        },
        selectSchool(school) {
            this.registrationForm.school_name = school.school_name;
            this.schoolId = school.id;
            this.showDropdown = false;
            this.$emit('selected', school); // Send selected data to parent
        },
    },
}
</script>


<style scoped lang="scss">

.top-spot {
    margin-top: 30rem;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    h5 {
        cursor: pointer;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #4B4B4F;
        span {
            margin-right: 20px;
        }
    }
}

.header-top {
    margin-top: 40px;
    h4 {
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        color: #4B4B4F; 
        text-align: left;
    }

    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        color: #5D6F7C;
        text-align: left;

    }   
}
label {
  display: flex;
}


label:not(.form-check-label) {
    font-family: Lato;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #1C2B3A;
    text-align: left;
    display: block;
}
.form-check-label {
    margin-bottom: 0;
    font-family: Lato;
    font-weight: 500;
    font-size: 16px;
    color: #1C2B3A;
    padding-left: 12px;
    padding-top: 4px;
}
.form-check {
  margin-bottom: 27px;
}
input[type="radio"] {
    appearance: none;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #ccc; /* Unselected ring width */
    border-radius: 50%;
    outline: none;
    cursor: pointer;
}

input[type="radio"]:checked {
    border-width: 6px; /* "Ring" thickens when selected */
    border-color: #2EBFCA;
}

input[type="checkbox"]:checked {
    border-width: 6px; /* "Ring" thickens when selected */
    border-color: #2EBFCA;
}

input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #ccc; /* Unselected ring width */
    outline: none;
    cursor: pointer;
}
.inputt {
    height: 48px;
    border-radius: 8px;
    padding: 12px;
    border: 1px solid #e8e9e9;
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    // color: #A3A3A3;
    color: #4B4B4F;
    outline: 0;
    box-shadow: none;

}

.vote-btn {
    margin-top: 40px;
    .vote-now {
        background: #2AB3E6;
        color: #ffffff;
        border-radius: 8px;
        min-height: 38px;
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        width: 100%;
        outline: 0;
        box-shadow: none;
    }
}
.card-img-top {
    cursor: pointer;
}
.activePick {
    border: 4px solid #d2d1d1;
    border-radius: 19.5px;
}

.radio-options {
  border: 2px solid #F5F7FA;
  padding: 20px;
  border-radius: 12px;
  text-align: left;
  background: #ffffff;
}

.search-container {
  position: relative; 
  width: 100%;
}

.dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  display: none;
  list-style: none;
  padding: 0;
}

.dropdown-content li {
  padding: 10px;
  cursor: pointer;
}

.dropdown-content li:hover {
  background-color: #f1f1f1;
}

@media (max-width: 767.98px) {
  .custom-mobile-row {
    margin-right: -4px !important;
    margin-left: -4px !important;
  }
  .custom-mobile-row > .col-6 {
    padding-right: 4px !important;
    padding-left: 4px !important;
  }
}

.open-add-sch-btn {
    button {
        border-radius: 8px;
        min-height: 38px;
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        width: 100%;
        outline: 0;
        box-shadow: none;
        height: 48px;
    }
    .cancel {
        border: 1px solid #2AB3E6;
        color: #2AB3E6;
        background-color: transparent;
    }
    .openSchool {
        background-color: #2AB3E6;
        color: #ffffff;
    }
}
.openSchoolAction {
    background-color: #2AB3E6;
    color: #ffffff;
    border-radius: 8px;
    min-height: 38px;
    font-family: Lato;
    font-weight: 600;
    font-size: 16px;
    width: 100%;
    outline: 0;
    box-shadow: none;
    height: 48px;
}
</style>